import { AfterViewInit, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
import { Token } from './auth/models/token.model';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  isLoading = true;
  title = 'gmr';
  constructor(private router: Router, private ngxService: NgxUiLoaderService) {
    this.router.events.subscribe((event) => {
      if (event instanceof RouteConfigLoadStart) {
        this.ngxService.startBackground();
      } else if (event instanceof RouteConfigLoadEnd) {
        this.ngxService.stopBackground();
      }
    });
    // subscribing to router events to scroll to the top of the screen in each page navigation

    this.router.events.subscribe((ev) => {
      if (ev instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
  }

  ngOnInit() {
    window.addEventListener('storage', (event) => {
      if (event.storageArea === localStorage) {
        const token = <Token>JSON.parse(localStorage.getItem('jwtToken'));
        if (!token) {
          this.router.navigateByUrl('/auth/login');
        }
      }
    }, false);
  }
}


